module.exports = function () {
	window.onscroll = () => {
		const scrollTop = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
		const scrollTotal = scrollTop / document.documentElement.offsetHeight;
		// Plant, Base, Mountains, Earth
		$('footer').style.backgroundPosition = `100% 100%, 50% ${100 * scrollTotal}%, bottom ${44 * scrollTotal}vw right 50%, 50% ${110 * scrollTotal}%`;
	};
	const rellax = new Rellax('.rellax');
};
